import { toTimestamp } from '../utils/addWebSocketToReplication'
import { toISOString, toISOStringOrNull } from '../utils/pushSafetyUtils'
import { createReplication } from './createReplication'
import type { RxCollection } from 'rxdb'
import type { PageContentDocument } from '../schemas/pageContent'

export type PageContentCollection = RxCollection<PageContentDocument>

/**
 * Setup bidirectional replication for page content with WebSocket real-time updates.
 * Separate from page replication to prevent conflicts and enable future collaboration.
 */
export const setupPageContentReplication = (
  collection: PageContentCollection,
  envId: string,
) =>
  createReplication({
    entityName: 'documentcontent',
    displayName: 'PageContent',
    collection,
    envId,
    mapFromServer: (doc) => ({
      id: doc.id,
      pageId: doc.documentId || doc.pageId, // Backend sends documentId
      envId: doc.envId,
      isDeleted: doc.isDeleted || false,
      content: doc.content || '',
      format: doc.format || 'tiptap',
      length: doc.length || 0,
      plainText: doc.plainText,
      version: doc.version || 1,
      createdOn: toTimestamp(doc.createdOn) ?? new Date(doc.createdOn).getTime(),
      createdBy: doc.createdBy,
      updatedOn: toTimestamp(doc.updatedOn) ?? new Date(doc.updatedOn).getTime(),
      updatedBy: doc.updatedBy,
      deletedOn: doc.deletedOn ? (toTimestamp(doc.deletedOn) ?? new Date(doc.deletedOn).getTime()) : null,
      deletedBy: doc.deletedBy,
    }),
    mapToServer: (state, envId) => ({
      id: state.id,
      documentId: state.pageId, // Frontend uses pageId, backend expects documentId
      envId,
      isDeleted: state.isDeleted || false,
      content: state.content || '',
      format: state.format || 'tiptap',
      length: state.length || 0,
      plainText: state.plainText,
      version: state.version || 1,
      createdOn: toISOString(state.createdOn),
      createdBy: state.createdBy,
      updatedOn: toISOString(state.updatedOn),
      updatedBy: state.updatedBy,
      deletedOn: toISOStringOrNull(state.deletedOn),
      deletedBy: state.deletedBy || null,
    }),
  })
